import React, { useEffect, useState } from "react";
import {DividerTitle} from "../../BlogEntries/utils";
import {createStyles, Text, Group, rem, Paper, Button, TextInput, Textarea, Grid, Title, useMantineTheme} from '@mantine/core';
import {IconUserCircle, IconMessage2Plus, IconArrowNarrowRight, IconX} from "@tabler/icons-react";
import { modals } from '@mantine/modals';
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { IconCheck } from '@tabler/icons-react';
import { useMediaQuery } from "@mantine/hooks";

import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, addDoc, Timestamp, query, where } from 'firebase/firestore';
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
  
// Initialisieren Sie Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);


export default function CommentSection({entry_id}: {entry_id: string}){
    const theme = useMantineTheme();
    const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
    const [comments, setComments] = useState([])

    // Load comments
    useEffect(()=>{
        const auth = getAuth();
        signInAnonymously(auth)
            .then(() => {
                const comments_ref = collection(firestore, 'comments')
                const site_query = query(comments_ref, where("entry_id", "==", entry_id))
                getDocs(site_query).then((querySnapshot) => {
                    const commentsData = querySnapshot.docs.map((doc) => doc.data()).reverse()
                    //@ts-ignore
                    setComments(commentsData)
                })
            })
    }, [entry_id])

    const newComment = () => {
        modals.open({
            title: <Title order={4}>Neuen Kommentar erstellen</Title>,
            size: mobile? "90%":"xl",
            xOffset: "-10%",
            zIndex: 10000,
            radius: "md",
            centered: true,
            id: "newCommentModal",
            children: (
                <NewCommentFormChild commentOrder={0} parentComment={null} entry_id={entry_id} setComments={setComments} comments={comments} />
            )
          });
    }

    const comment_jsx = comments.map((params: any)=>{
        return (
            <Comment 
                key={params.entry_id + params.username + params.posted_at.toString()} 
                setComments={setComments} 
                comments={comments} 
                entry_id={entry_id} 
                author_name={params.username} 
                id={params.entry_id} 
                order={params.order} 
                postedAt={params.posted_at.toDate()} 
                body={
                <div>
                    <Text>
                        {params.text}
                    </Text>
                </div>
            } />
        )
    })

    return (
        <div>
            <div style={{height:rem(100)}}/>
            <DividerTitle title={"Kommentare"} order={3} t_id={"kommentare"} variant={"dashed"} position="left"/>
            <Button
                variant="white"
                leftIcon={<IconMessage2Plus size={14} />}
                rightIcon={<IconArrowNarrowRight size={14} />}
                onClick={newComment}
                style={{zIndex:1}}
            >
                Neuen Kommentar erstellen
            </Button>
            {comment_jsx}
        </div>
    )
}

const useStyles = createStyles((theme) => ({
    body: {
        paddingLeft: rem(54),
        paddingTop: theme.spacing.sm,
    },
    comment: {
        padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
        marginBottom: theme.spacing.md,
    },
}));

interface CommentProps {
    postedAt: Date;
    body: string | React.ReactNode;
    author_name: string,
    order: number,
    id: number,
    entry_id: string,
    setComments: any,
    comments: object
}


function Comment({ postedAt, body, author_name, order, id, entry_id, setComments, comments}: CommentProps) {
    //const theme = useMantineTheme();
    //const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
    const { classes } = useStyles();
    const with_border = (order===0)
    // eslint-disable-next-line
    {/*
    const addComment = () => {
        modals.open({
            title: <Title order={4}>Neuen Kommentar erstellen</Title>,
            size: mobile? "90%":"xl",
            xOffset: "-10%",
            zIndex: 10000,
            radius: "md",
            centered: true,
            id: "addCommentModal",
            children: (
                <NewCommentFormChild commentOrder={order+1} parentComment={id} entry_id={entry_id} setComments={setComments} comments={comments} />
            )
          });
    }
    */}
    return (
        <div>
            {
                with_border?
                    <Paper withBorder radius="md" className={classes.comment}>
                        <Group>
                            <IconUserCircle size={rem(40)} fontSize={"1"} />
                            <div>
                                <Text weight={500} size="sm">{author_name}</Text>
                                <Text size="xs" color="dimmed">
                                    {postedAt.toLocaleDateString()}
                                </Text>
                            </div>
                        </Group>
                        <Text className={classes.body} size="sm">
                            {body}
                        </Text>
                        {/*<Button 
                            variant="white"
                            leftIcon={<IconMessage2Plus size={14} />}
                            rightIcon={<IconArrowNarrowRight size={14} />}
                            onClick={addComment}
                        >
                            Kommentieren
                        </Button>*/}
                    </Paper> :
                    <div>
                        <Group>
                            <IconUserCircle size={rem(40)} fontSize={"1"} />
                            <div>
                                <Text weight={500} size="sm">{author_name}</Text>
                                <Text size="xs" color="dimmed">
                                    {postedAt.toLocaleDateString()}
                                </Text>
                            </div>
                        </Group>
                        <Text className={classes.body} size="sm">
                            {body}
                        </Text>
                        {/*<Button 
                            variant="white"
                            leftIcon={<IconMessage2Plus size={14} />}
                            rightIcon={<IconArrowNarrowRight size={14} />}
                            onClick={addComment}
                        >
                            Kommentieren
                        </Button>*/}
                    </div>
            }
        </div>
    );
}

function NewCommentFormChild({commentOrder, parentComment, entry_id, setComments, comments}: {commentOrder : Number, parentComment: Object | null, entry_id: string, setComments: any, comments: any}){ // 0 is top comment
    const newCommentForm = useForm({
        initialValues: {
            username: '',
            commentContent: ''
        },
      
        validate: {
            username: (value) => value.length >= 3 ? null : 'Der Name muss mindestens 3 Buchstaben lang sein',
            commentContent: (value) => value.length >= 3 ? null: "Der Kommentar muss mindestens 3 Buchstaben lang sein"
        },
    })

    const postNewComment =  (values:any) => {
        modals.closeAll()
        notifications.show({
            id: "newCommentID",
            title: 'Bitte warten ...',
            message: 'Der Kommentar wird gepostet ...',
            loading: true,
            color: "green",
            autoClose: false,
            withCloseButton: false,
        })

        const new_comment = {
            entry_id: entry_id,
            order: commentOrder,
            parent_id: parentComment,
            posted_at: Timestamp.now(),
            text: values.commentContent,
            username: values.username
        }

        addDoc(collection(firestore, 'comments'), new_comment).then((querySnapshot) => {

            setComments([...comments, new_comment])
            notifications.update({
                id: "newCommentID",
                color: "green",
                autoClose: 3000,
                message: 'Danke für deinen Kommentar',
                title: "Kommentar wurde gepostet",
                icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
                loading: false
    
            })
            return null
        }).catch((err)=>{
            notifications.update({
                id: "newCommentID",
                color: "red",
                autoClose: 3000,
                message: 'Der Kommentar konnte nicht geposted werden. Fehler: ' + err,
                title: "Fehler beim Posten :(",
                icon: <IconX style={{ width: rem(18), height: rem(18) }} />,
                loading: false
    
            })
        })
    }

    return (
        <form onSubmit={newCommentForm.onSubmit(postNewComment)}>
            <Grid>
                        <Grid.Col xs={12}>
                            <TextInput withAsterisk label="Anzeigename" placeholder="Name" {...newCommentForm.getInputProps("username")} />
                        </Grid.Col>
                        <Grid.Col xs={12}>
                            <Textarea 
                                minRows={6}
                                withAsterisk 
                                label="Kommentar" 
                                placeholder="Kommentartext" 
                                {...newCommentForm.getInputProps("commentContent")} 
                            />
                        </Grid.Col>
                        <Grid.Col xs={12}>
                            <Group grow>
                                <Button variant="light" type="submit" mt="md">
                                    Veröffentlichen
                                </Button>
                                <Button variant="outline" color="red" mt="md" onClick={()=> modals.closeAll()}>
                                    Abbrechen
                                </Button>
                            </Group>
                        </Grid.Col>
                    </Grid>
                    
        </form>
    )
}